<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Pumpe"}} {{label}}</h4>
</div>
<div class="modal-body">
	<div id="error-msg" class="alert alert-danger invisible">{{TR 'Wert konnte nicht geschrieben werden.'}}</div>
	<div class="form-group">
		<label for="js-pump-state" class="control-label">{{TR "Zustand"}}</label>
		<select class="form-control" id="js-pump-state">
			<option value="auto" {{#COMPARE state "auto"}}selected="selected"{{/COMPARE}}>
				{{TR "Auto"}}
			</option>
			<option value="on" {{#COMPARE state "on"}}selected="selected"{{/COMPARE}}>
				{{TR "Ein"}}
			</option>
			<option value="off" {{#COMPARE state "off"}}selected="selected"{{/COMPARE}}>
				{{TR "Aus"}}
			</option>
		</select>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
